<button type="button"
        class="btn btn-secondary"
        adaptButtonIcon="add"
        [adaptBlockingClick]="instance.saveAndClose"
        [adaptBlockingClickParam]="true"
        [disabled]="!instance.isValid.value || instance.submitting"
        adaptTooltip="This will create the group immediately. Details can be changed from the group's configuration page at any time."
        data-test="create-team-button">Create group now</button>
